import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';

import zh from '../locales/zh-Hant.json';
import en from '../locales/en.json';

Vue.use(VueI18n);

let locale = 'zh-Hant';

if (typeof Cookies.get('ocard_order_lang') === 'string') {
  if (Cookies.get('ocard_order_lang').includes('en')) {
    locale = 'en';
  }
} else if (typeof (window.navigator.language || window.navigator.userLanguage) === 'string' && (window.navigator.language || window.navigator.userLanguage).includes('en')) {
  locale = 'en';
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'zh-Hant',
  messages: {
    'zh-Hant': zh,
    en,
  },
});

export default i18n;
